import { render, staticRenderFns } from "./PieWidget.vue?vue&type=template&id=9532095c&"
import script from "./PieWidget.vue?vue&type=script&lang=js&"
export * from "./PieWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports